export const LOGIN = "LOGIN";
export const SET_LOGGED_USER = "SET_LOGGED_USER";
export const SET_LOADING = "SET_LOADING";
